<div class="container" >
    <div class="row d-flex justify-content-center">
        <div class="col-md-4 ">
            <!--FORM1 Start-->
            <div class="card-body">
               
                <div class="alert alert-success" role="alert" *ngIf="bool_success">
                    {{reciveuserstatus}}
                  </div>
            
                <div class="alert alert-danger" role="alert" *ngIf="bool_failure">
                    {{reciveuserstatus}}
                  </div>
  
                <!-- <h2>SINGLE / BULK</h2> -->
               
                <form [formGroup]="otpForm" (ngSubmit)="onOtpSubmit()">
                    <div class="form-row">
                      <div class="form-group col-12">
                          <label>OTP <span class="clr_red"> * </span></label>

                        

                          <input type="text" formControlName="userid" [(ngModel)]="reciveuserid" class="form-control" 
                              />

                              <input type="text" formControlName="otp" class="form-control"
                              [ngClass]="{ 'is-invalid': submittedOtp && f.otp.errors }" maxlength="50"
                              placeholder="Enter Your User ID" (keypress)="omit_spl($event)" />
                          <div *ngIf="submittedOtp && f.otp.errors" class="invalid-feedback">
                              <div *ngIf="f.otp.errors.required">Enter Your OTP</div>
                          </div>
                          
                          <p class="pad-btm-empty">Enter OTP sent in your registered email or mobile </p>
                      </div>
                       

                    </div>
                    <hr>
                    <div class="form-row">
                        <div class="form-group col-12">
                            <div class="text-center">
                                <button class="btn btn-primary mr-1">Submit</button>
                            </div>
                            <div *ngIf="bool_spinner" class="bg-overlay_cls">
                              Please Wait...
                              </div>

                        </div>
                    </div>
                </form>

              </div>
              </div>
            </div>
        </div>
